export class GetPossibleTransferBasketRecipientsRequest{
  endpointUrl: URL
  method = 'GET' as const

  constructor(endpoint: string, shopId: number, partyId: number) {
    this.endpointUrl = new URL(endpoint + 'GetPossibleTransferBasketRecipients/', window.location.href)
    this.endpointUrl.searchParams.append('shop_id', shopId.toString())
    this.endpointUrl.searchParams.append('party_id', partyId.toString())
  }
}
